<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'menu'})" icon :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>
            <!-- Caption -->
            <v-row class="RestoRegular pt-5 pl-4" style="height:40px; font-size: 22px; color: #4D4D4D; line-height: 18px">
                ¡Hola!
            </v-row>
            <v-row class="RestoRegular pl-4" style="height:30px; font-size: 22px;" :style="{ 'color': $store.state.colors.primary }"> 
                {{userData.nombre}}
            </v-row>

            <!-- Menu bar -->
            <v-row justify="center" style="height: 110px">

                <v-col cols="3" >
                    <v-row justify="center">
                        <v-card @click="currentComponent = 'userDetails'; clickedA()" width="90px" height="95px"  elevation="0" v-bind:style="{ 'background-color': colorCardA }">
                            <!-- <v-col style="color: black;"> 
                                <v-row justify="center">
                                    <v-img :src="require('@/assets/resources/user/datos-perfil' + imageA + '.svg')" max-width="75px"></v-img>
                                </v-row>                         
                            </v-col> -->
                            <v-img :src="require('@/assets/resources/user/datos-perfil' + imageA + '.svg')" contain width="90px" height="95px"></v-img>
                        </v-card>
                    </v-row>
                </v-col>

                <v-col cols="3" >
                    <v-row justify="center">
                        <v-card @click="currentComponent = 'addresses'; clickedB()" width="90px" height="95px"  elevation="0" v-bind:style="{ 'background-color': colorCardB }">
                            <!-- <v-col style="color: black;">
                                <v-row justify="center">
                                    <v-img :src="require('@/assets/resources/user/mis-direcciones' + imageB + '.svg')" max-width="75px"></v-img>
                                </v-row>
                            </v-col> -->
                            <v-img :src="require('@/assets/resources/user/mis-direcciones' + imageB + '.svg')" contain width="90px" height="95px"></v-img>
                        </v-card>
                    </v-row>
                </v-col>

                <v-col cols="3" >
                    <v-row justify="center">
                        <v-card @click="currentComponent = 'history'; clickedC();" width="90px" height="95px"  elevation="0" v-bind:style="{ 'background-color': colorCardC }">
                            <!-- <v-col style="color: black;">
                                <v-row justify="center">
                                    <v-img :src="require('@/assets/resources/user/historial' + imageC + '.svg')" max-width="75px"></v-img>
                                </v-row>
                            </v-col> -->
                            <v-img :src="require('@/assets/resources/user/historial' + imageC + '.svg')" contain width="90px" height="95px"></v-img>
                        </v-card>
                    </v-row>
                </v-col>

                <v-col cols="3" >
                    <v-row justify="center">
                        <v-card @click="currentComponent = 'paymentMethods'; clickedD()" width="90px" height="95px"  elevation="0" v-bind:style="{ 'background-color': colorCardD }">
                            <!-- <v-col style="color: black;">
                                <v-row justify="center">
                                    <v-img :src="require('@/assets/resources/user/metodos-pago' + imageD + '.svg')" max-width="75px"></v-img>
                                </v-row>                          
                            </v-col> -->
                            <v-img :src="require('@/assets/resources/user/metodos-pago' + imageD + '.svg')" contain width="90px" height="95px"></v-img>
                        </v-card>
                    </v-row>
                </v-col>

            </v-row>

            <!-- Componente view -->
            <v-row class="hidscroll mb-0 pb-0" style="height: 100%;" >
                
                    <component :is="currentComponent" class="pb-0" >
                    </component>
                
            </v-row>
            

        </v-col>
    </v-row>
</template>


<script>

import userDetails from './userDetails'
import addresses from './addresses'
import history from './history'
import paymentMethods from './paymentMethods'

export default {
    data() {
        return {
            username: localStorage.getItem("nombre_cliente"),
            currentComponent: "userDetails",
            clickA: true,
            imageA: "-bco",
            colorCardA: this.$store.state.colors.primary,
            clickB: false,
            imageB: "",
            colorCardB: 'white',
            clickC: false,
            imageC: "",
            colorCardC: 'white',
            clickD: false,
            imageD: "",
            colorCardD: 'white',
            userData:
            {
                nombre: ''
            }
        }
    },
    components: {
        userDetails,
        addresses,
        history,
        paymentMethods
    },
    methods: {
        clickedA() {
            this.colorCardA = this.$store.state.colors.primary;    this.imageA = '-bco';   this.clickA = true;
            this.colorCardB = 'white';      this.imageB = '';       this.clickB = false;
            this.colorCardC = 'white';      this.imageC = '';       this.clickC = false;
            this.colorCardD = 'white';      this.imageD = '';       this.clickD = false;
        },
        clickedB() {
            this.colorCardB = this.$store.state.colors.primary;    this.imageB = '-bco';   this.clickB = true;
            this.colorCardA = 'white';      this.imageA = '';       this.clickA = false;
            this.colorCardC = 'white';      this.imageC = '';       this.clickC = false;
            this.colorCardD = 'white';      this.imageD = '';       this.clickD = false;
        },
        clickedC() {
            this.colorCardC = this.$store.state.colors.primary;    this.imageC = '-bco';   this.clickC = true;
            this.colorCardB = 'white';      this.imageB = '';       this.clickB = false;
            this.colorCardA = 'white';      this.imageA = '';       this.clickA = false;
            this.colorCardD = 'white';      this.imageD = '';       this.clickD = false;
        },
        clickedD() {
            this.colorCardD = this.$store.state.colors.primary;    this.imageD = '-bco';   this.clickD = true;
            this.colorCardB = 'white';      this.imageB = '';       this.clickB = false;
            this.colorCardC = 'white';      this.imageC = '';       this.clickC = false;
            this.colorCardA = 'white';      this.imageA = '';       this.clickA = false;
        },
    },
    created() {
        if(this.$route.params.name)
        {
            this.clickedC();
            // console.log("ROUTE VAR: ", this.$route.params.name );
            this.currentComponent = this.$route.params.name;
        }
        this.$store.state.hideFooter = false;

        // console.log(localStorage.getItem("id_cliente"));
        this.$store.dispatch("GET", {url: '/datos_c/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                this.userData = response.data[0];
                localStorage.setItem("nombre_cliente", this.userData.nombre)
                // console.log(this.userData);
            })
            .catch(error => {
                console.log("Error: " + error);
                this.$router.push({ name: 'verification'});
                // console.log("EXIT");
                this.$store.state.validationDelivery=false;
                localStorage.removeItem('comentarios'); 
                localStorage.removeItem('metodo_envio'); 
                localStorage.removeItem('token'); 
                this.$store.state.token = null; 
                this.$store.state.logo = false;
                localStorage.removeItem('id_cliente'); 
                this.$store.state.id_cliente = null; 
                localStorage.removeItem('id_sucursal'); 
                this.$store.state.id_sucursal = null; 
                localStorage.removeItem('nombre_cliente'); 
                this.$store.state.nombre_cliente = null; 
                this.$router.push({ name: 'logo'});
                localStorage.removeItem('tokenDM'); 
                this.$store.state.tokenDM = null;
            });
    },
}
</script>

<style scoped>
    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }

</style>